import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { PLATFORMS } from '@/lib/clipPlatformFormats';

/**
 * Optimize → Platforms: choose which platforms get their OWN independent
 * variant for the selected content (section 11). Checking a platform
 * creates a new, separate variant record; unchecking removes that
 * platform's variant only — every other platform's title/description/
 * keywords/thumbnail/score/approval stays exactly as it was.
 */
export function OptimizePlatformsPanel({ variants, onTogglePlatform, disabled }) {
  const activePlatforms = new Set(variants.map((v) => v.platforms[0]));
  return (
    <div className="space-y-2" data-testid="optimize-platforms-panel">
      {disabled && <p className="text-xs text-[#8A93A6] text-center py-4" data-testid="optimize-platforms-empty">Select content in Media first.</p>}
      {!disabled && PLATFORMS.map((p) => {
        const on = activePlatforms.has(p.key);
        return (
          <label key={p.key} className={`flex items-center gap-2 p-2.5 rounded-lg border cursor-pointer ${on ? 'border-[#3A7BFF] bg-[#3A7BFF]/10' : 'border-white/10 hover:bg-white/5'}`} data-testid={`optimize-platform-toggle-${p.key}`}>
            <Checkbox checked={on} onCheckedChange={() => onTogglePlatform(p.key)} />
            <span className="text-sm text-white">{p.label}</span>
          </label>
        );
      })}
      {!disabled && (
        <p className="text-[11px] text-[#555E6E] pt-1">Each checked platform gets its own title, description, keywords, thumbnail and score — editing one never changes another.</p>
      )}
    </div>
  );
}
